/**
 * Created by jv on 26/01/2017.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/languagemanager");
const utils = require("Sources/utils/utils");
const StoreShared = require("Sources/store-shared");

//Styles
require("Styles/pages/store/store-info.scss");


$(function()
{
  info.init();
});

var info = {};

(function(Info)
{
  Info.init = function()
  {
    setUpPage();

    LanguageManager.init(function()
    {
      StoreShared.init();
    }, Shared.defaultLocale);
  };

  function setUpPage()
  {
    var infoPageHTML = $(getInfoPartialFromUrl());

    var storeInfoContentEl = $("#store-info-content");

    storeInfoContentEl.empty().append(infoPageHTML);
  }

  function getInfoPartialFromUrl()
  {
    var locale = utils.getPathSection(1);
    var userType = utils.getPathSection(4);

    var req = require.context("Views/store/info", true, /^\.\/.*\.jsp$/);

    try
    {
      var infoPageRequire = "./" + locale + "/" + userType + ".jsp";

      if($.inArray(infoPageRequire, req.keys()) !== -1)
      {
        return req(infoPageRequire);
      }
      else
      {
        console.error("Info page [%s] doesn't exist", infoPageRequire);
      }
    }
    catch(e)
    {
      console.error(e);
    }

    return null;
  }

}(info));



// WEBPACK FOOTER //
// ./app/js/entries/store/store-info.js